import React from 'react';

const CollapseIconSVGR = () => (
  <svg
    aria-hidden='true'
    className='kadence-svg-icon kadence-menu-svg'
    fill='#00362b'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <title>Toggle Menu</title>
    <path d='M3 13h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 7h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 19h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1z' />
  </svg>
);

export default CollapseIconSVGR;
